import { DISABLE_SHIPPING_ADDRESS_MODAL } from './types';
import { enableBodyScroll } from '../../util';

const disableShippingAddressModal = () => {
  enableBodyScroll();
  return { type: DISABLE_SHIPPING_ADDRESS_MODAL };
};

export default disableShippingAddressModal;



// WEBPACK FOOTER //
// ./src/actions/modals/disableShippingAddressModal.js